import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  banner: {
    width: '100%',
    maxWidth: '700px',
    margin: '0 auto',
    padding: theme.spacing(0),
  },
  content: {
    textAlign: 'center',
  },
  button: {
    marginTop: theme.spacing(0),
  }
}));

const PromotionalBanner: React.FC = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    // Check if banner should be shown based on date and local storage
    const hasSeenBanner = false; //localStorage.getItem('hasSeenPromoBanner');
    const currentDate = new Date();
    const expirationDate = new Date('2025-11-18');

    if (!hasSeenBanner && currentDate <= expirationDate) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    // Store that user has seen the banner
    localStorage.setItem('hasSeenPromoBanner', 'true');
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="promo-banner-dialog"
      maxWidth="md"
    >
      <DialogContent className={classes.content}>
        <Box className={classes.banner}>
            <img src="/images/banners/STATS_RENT_A4.png" style={{ width: '100%', maxHeight: '600px' }} alt="Darba laiks svētkos" />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          onClick={handleClose}
          className={classes.button}
        >
          Iepazinos
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromotionalBanner;